var IsActiveStatus = {
  INACTIVE: 0,
  ACTIVE: 1
}

export { IsActiveStatus }
